import { useState } from 'react';
import { Button } from '@/components/ui/Button';
import { downloadApiFile } from '@/lib/downloadApi';
import { useToast } from '@/components/toast/ToastProvider';

type Props = {
  projectId: string;
  from: string;
  to: string;
};

export function AnalyticsCsvExport({ projectId, from, to }: Props) {
  const toast = useToast();
  const [busy, setBusy] = useState(false);

  async function onExport() {
    setBusy(true);
    try {
      const qs = new URLSearchParams({ project_id: projectId, from, to });
      await downloadApiFile(`/api/analytics/export?${qs.toString()}`, `analytics-${from}-${to}.csv`);
      toast.push('CSV gedownload', 'success');
    } catch (e) {
      toast.push((e as Error).message, 'error');
    } finally {
      setBusy(false);
    }
  }

  return (
    <Button variant="secondary" type="button" disabled={busy} onClick={() => void onExport()}>
      {busy ? 'Export…' : 'CSV export'}
    </Button>
  );
}
